import React, { useState } from "react";
import "./SignUp.css"; // Import the CSS file
// import "../../../src/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoMdCloseCircle } from "react-icons/io";
import { GiCombinationLock } from "react-icons/gi";
import {
  FaMobileAlt,
  FaCaretDown,
  FaUser,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa"; // Import icons
import axios from "axios";
import apiBaseUrl from "../../config/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const SignUp = (props) => {
  const navigate = useNavigate();
  const { signup } = useAuth();

  const [formData, setFormData] = useState({
    site_code: apiBaseUrl.sitecodes,
    user_name: "",
    password: "",
    user_type: "User",
    master_id: apiBaseUrl.childAdmin, // Default to child admin
    refercode: "",
    otp: "",
  });

  // console.log("apiBaseUrl", apiBaseUrl);

  const [showPopup, setShowPopup] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // State to toggle password visibility
  const [otpBtn, setOtpBtn] = useState(false); // State to toggle password visibility

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    
    event.preventDefault();
    // console.log("formData", formData);
    // return false;
    if (confirmPassword !== formData.password) {
      toast.error("Password Not Matched!", { autoClose: 2000 });
      return false;
    }
    if (!formData?.otp) {
      toast.error("Otp Not Matched!", { autoClose: 2000 });
      return false;
    }

    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}users/addUsers`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(formData),
    };
    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success("Registered successful!", { autoClose: 2000 });

          // localStorage.setItem(
          //   "userdata",
          //   JSON.stringify(response.data.resultData)
          // );
          console.log("response.data.resultData", response.data.resultData);
          signup(response.data.resultData[0]);

          // setTimeout(() => {
          //   props?.toggleSignUpPopup(false);
          //   props?.handleClose();
          // }, 1000);
          if (props?.togglePopup) {
            props.togglePopup("Yes");
          }
          if (props?.handleClose) {
            props.handleClose();
          }
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
        toast.error("An error occurred during registering", {
          autoClose: 2000,
        });
      });
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle between showing and hiding password
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword); // Toggle between showing and hiding password
  };

  async function getOtp() {
    const mobileNumber = String(formData.user_name).trim();

    if (!/^\d{10}$/.test(mobileNumber)) {
      toast.error("Please enter a valid 10 digit mobile number", {
        autoClose: 2000,
      });
      return;
    }

    setOtpBtn(true);
    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}otps/sendOtp`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        user_name: mobileNumber,
        site_code: apiBaseUrl.sitecodes,
      }),
    };
    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success("OTP Send successful!", { autoClose: 2000 });
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
        setOtpBtn(false);
      })
      .catch(function (error) {
        console.log(error);
        toast.error("An error occurred during sending OTP", {
          autoClose: 2000,
        });
        setOtpBtn(false);
      });
  }

  return (
    <>
      {/* Login Button */}
      {/* <button type="button" className="btn btn-warning" onClick={togglePopup}>Sign Up</button> */}
      {/* <button className="pushable-signup submit-btn login-trigger " onClick={togglePopup}>
        <span className="front-signup">Sign Up</span> 
      </button> */}

      {/* Popup */}
      {props?.showSignupPopup && (
        <div className="login-popup-overlay" onClick={props?.toggleSignUpPopup}>
          <div
            className="login-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="close-btn">
              <IoMdCloseCircle onClick={props?.toggleSignUpPopup} />
            </span>
            <div className="login-popup-logo">
              <img className="form-logo" src="../Images/logo.png" alt="" />
            </div>
            <form className=" text-[#000]" onSubmit={handleSubmit}>
              <div className="phnumber-signup" style={{borderRadius:"8px"}}>
                <span className="country-code">+91</span>
                <input
                  type="number"
                  name="user_name"
                  style={{ width: "100%", border: "none" }}
                  value={formData.user_name}
                  onChange={(e) => handleInputChange(e)}
                  placeholder="Enter Your 10 Digit Number"
                  className="phnumber"
                  required
                />
                <button
                  type="button"
                  className="getotp p-1"
                  disabled={otpBtn}
                  onClick={getOtp}
                >
                  Get OTP
                </button>
              </div>
              <div className="signup-otp">
                <input
                  type="number"
                  name="otp"
                  value={formData.otp}
                  onChange={(e) => handleInputChange(e)}
                  placeholder="Enter OTP"
                  className="otp-input"
                  style={{ borderRadius: "8px", height:"43px" }}
                />
              </div>
              <div className="signup-password" style={{ borderRadius: "8px", height:"43px" }}>
                <GiCombinationLock
                  size={20}
                  color="#e9b02e"
                  style={{ marginRight: 0, marginLeft: 5 }}
                />
                <input
                  className="password-input"
                  type={showPassword ? "text" : "password"} // Toggle between 'text' and 'password'
                  name="password"
                  placeholder="Password"
                  required
                  value={formData.password}
                  onChange={(e) => handleInputChange(e)}
                  style={{marginTop:"0px"}}
                />
                <span
                  className="password-toggle-signup mr-1"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <FaEyeSlash size={20} />
                  ) : (
                    <FaEye size={20} />
                  )}
                </span>{" "}
                {/* Eye icon to toggle password visibility */}
              </div>
              <div className="signup-password" style={{ borderRadius: "8px", height:"43px" }}>
                <GiCombinationLock
                  size={20}
                  color="#e9b02e"
                  style={{ marginRight: 0, marginLeft: 5 }}
                />
                <input
                  className="password-input"
                  type={showConfirmPassword ? "text" : "password"} // Toggle between 'text' and 'password'
                  name="confirmpass"
                  placeholder="Confirm Password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={{marginTop:"0px"}}
                />
                <span
                  className="confirm-password-toggle-signup mr-1"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {showConfirmPassword ? (
                    <FaEyeSlash size={20} />
                  ) : (
                    <FaEye size={20} />
                  )}
                </span>{" "}
                {/* Eye icon to toggle password visibility */}
              </div>
              <input
                type="text"
                name="refercode"
                placeholder="Referral Code (if any)"
                value={formData.refercode}
                onChange={(e) => handleInputChange(e)}
                style={{marginTop:"0px", height:"43px", borderRadius: "8px"}}
              />
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label className="form-check-label" for="flexCheckDefault">
                  Remember me
                </label>
              </div>
              <button type="submit" className=" submit-btn">
                <span className="front">Register</span>
              </button>
              <span className="other-login">Or register with</span>
              <span className="other-button">
                {/* <button className="google border border-gray-500">
                  <div className="flex justify-center items-center">
                    <img
                      src="./Images/google.png"
                      alt=""
                      className="google-image"
                    />
                    <span className="text-[#fff]">Google</span>
                  </div>
                </button> */}
                <button
                  className="whatsapp"
                  onClick={() => props?.openWhatsApp(props?.whatsappNum)}
                >
                  <div className="flex justify-center items-center">
                    <img
                      src="./Images/whatsapp.png"
                      alt=""
                      className="whatsapp-image"
                    />
                    <span className="text-[#fff]">WhatsApp</span>
                  </div>
                </button>
              </span>
              <span
                className="new-account"
                onClick={() => props?.togglePopup()}
              >
                Already have an account? Login
              </span>{" "}
              {/* Added onClick event */}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default SignUp;
